import axios from 'axios';
import $ from 'jquery';
import _ from 'lodash';
import EncryptionHelper from './helpers/encryption';
import ClipboardJS from "clipboard";
import select2 from "select2";
import {handleSelect2Filter, initSelect2} from "./helpers/select2.js";
import {setOptions, importLibrary} from "@googlemaps/js-api-loader"
import {initTinyMCE} from "./vendors/tinymce.js";

window.axios = axios;
window._ = _;
window.EncryptionHelper = EncryptionHelper;
window.$ = window.jQuery = $;
window.tinymce = tinymce;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;


window.handleSelect2Filter = handleSelect2Filter;

window.initializeGoogleMaps = async function (apiKey = null) {

    navigator.geolocation.getCurrentPosition(async (position) => {
        if (apiKey) {
// Set the options for loading the API.

            const mapEl = document.getElementById("google-map-container");
            const placeAutocompleteEl = document.getElementById("google-place-auto-complate-container");
            // const mapOptions = {
            //     center: {lat: position.coords.latitude, lng: position.coords.longitude},
            //     zoom: 8,
            // };
            //
            //
            // // Or, if you prefer using callbacks instead of async/await:
            // importLibrary("maps").then(({Map}) => {
            //     map = new Map(mapEl, mapOptions);
            // });

            setOptions({
                key: "",
                version: "weekly",
            });

            const {Map} = await importLibrary("maps");
            const {AdvancedMarkerElement} = await importLibrary("marker");
            const map = new Map(mapEl, {
                center: {lat: position.coords.latitude, lng: position.coords.longitude},
                zoom: 8,
                mapId: "",
            });
            const marker = new AdvancedMarkerElement({
                map,
                position: {lat: position.coords.latitude, lng: position.coords.longitude},
            });

            await google.maps.importLibrary("places");
            const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement();
            placeAutocompleteEl.append(placeAutocomplete);

        }
    })

}

// General Common Lib Initialize
// clipboard
var clipboard = new ClipboardJS('.copy-btn');
clipboard.on('success', function (e) {
    alert('Copied Text: ' + e.text);
    e.clearSelection();
});

// select2
select2($);
$(document).ready(function () {
    initSelect2();
    initTinyMCE();
});


window.onload = function () {
    window.postToUrl = function (url, action) {
        if (confirm('Are you sure to ' + action + ' ?')) {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = url;

            // Add CSRF token if using Laravel
            const csrfToken = document.createElement('input');
            csrfToken.type = 'hidden';
            csrfToken.name = '_token';
            csrfToken.value = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            form.appendChild(csrfToken);

            document.body.appendChild(form);
            form.submit();
        }
    }

    window.postToUrlWithPrompt = function (url, action, reasonRequired = true) {
        let reason = prompt('Please provide reason to proceed ' + action + ' :');

        if (reason === null || reason.trim() === "") {
            alert("Action canceled. Reason is required.");
            return;
        }

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = url;

        // Add CSRF token if using Laravel
        const csrfToken = document.createElement('input');
        const reasonInput = document.createElement('input');
        csrfToken.type = 'hidden';
        csrfToken.name = '_token';
        csrfToken.value = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        reasonInput.type = 'text';
        reasonInput.name = 'reason'
        reasonInput.value = reason;
        form.appendChild(csrfToken);
        form.appendChild(reasonInput);

        document.body.appendChild(form);
        form.submit();
    }

    window.refreshWithoutQueryString = function () {
        window.location = window.location.href.split("?")[0];
    }
}
//todo Echo Pusher
